import { render, staticRenderFns } from "./StageGoldOrder.vue?vue&type=template&id=3f04097c"
import script from "./StageGoldOrder.vue?vue&type=script&lang=js"
export * from "./StageGoldOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports